"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPaginated = exports.getDefaultConfig = exports.getGraphQlClientsForChainOrThrow = exports.getGraphQlApiUrlsForChainOrThrow = exports.GRAPHQL_APIS = void 0;
const protocol_1 = require("@prophouse/protocol");
const graphql_1 = require("./evm/graphql");
exports.GRAPHQL_APIS = {
    [protocol_1.ChainId.EthereumMainnet]: {
        evm: 'https://api.thegraph.com/subgraphs/name/prop-house/prop-house',
        starknet: 'https://starknet-subgraph-mainnet-backup.onrender.com',
    },
    [protocol_1.ChainId.EthereumGoerli]: {
        evm: 'https://api.thegraph.com/subgraphs/name/prop-house/prop-house-goerli-v2',
        starknet: 'https://checkpoint-v2-api.onrender.com',
    },
    [protocol_1.ChainId.EthereumHardhat]: {
        evm: 'http://localhost:8020',
        starknet: 'http://localhost:3000',
    },
};
/**
 * Get GraphQL API URLs that have been deployed for a supported chain.
 * Throws if there are no known GraphQL APIs on the corresponding chain.
 * @param chainId The desired chainId
 */
const getGraphQlApiUrlsForChainOrThrow = (chainId) => {
    if (!exports.GRAPHQL_APIS[chainId]) {
        throw new Error(`Unknown chain id (${chainId}). No known GraphQL APIs exist for this chain.`);
    }
    return exports.GRAPHQL_APIS[chainId];
};
exports.getGraphQlApiUrlsForChainOrThrow = getGraphQlApiUrlsForChainOrThrow;
/**
 * Get API clients for all GraphQL APIs that have been deployed for a supported chain.
 * Throws if there are no known GraphQL APIs on the corresponding chain.
 * @param chainId The desired chainId
 */
const getGraphQlClientsForChainOrThrow = (chainId, getClientInstance) => {
    const apis = (0, exports.getGraphQlApiUrlsForChainOrThrow)(chainId);
    return Object.entries(apis).reduce((acc, curr) => {
        const [key, value] = curr;
        acc[key] = getClientInstance(value);
        return acc;
    }, {});
};
exports.getGraphQlClientsForChainOrThrow = getGraphQlClientsForChainOrThrow;
/**
 * Get the default request config when querying for many items
 * @param orderBy Which field to order the results by
 */
const getDefaultConfig = (orderBy) => ({
    page: 1,
    perPage: 50,
    orderBy: orderBy,
    orderDirection: graphql_1.OrderDirection.Desc,
});
exports.getDefaultConfig = getDefaultConfig;
/**
 * Convert the query
 * @param config The query config
 */
const toPaginated = (config) => ({
    first: config.perPage,
    skip: (config.page - 1) * config.perPage,
    orderBy: config.orderBy,
    orderDirection: config.orderDirection,
    where: config.where,
});
exports.toPaginated = toPaginated;
